require('./basics/http.js');
require('./basics/authHandoff.js');
require('./basics/money.js');
require('./basics/addressFields.js');
require('./basics/phoneSheet.js');
require('./basics/scrollLock.js');
require('./basics/forms.js');
require('./modules/captcha.js');
require('./basics/cookieHelper.js');
require('./basics/profileSession.js');
require('./basics/wishlist.js');

require('./events/appEvents.js');
require('./events/defaultEvents.js');


require('./modules/sentry');
require('vanilla-cookieconsent/dist/cookieconsent');
require('./basics/cookie');
require('./basics/utm.js');

require('./vendor/vue3.js');
require('./modules/login.js');
require('./modules/register.js');
require('./basics/orderRules.js');
require('./modules/orders.js');
require('./modules/orderManage.js');
require('./modules/contactForm.js');
require('./modules/ticketList.js');
require('./modules/searchLayer.js');
require('./modules/orderCaptcha.js');
require('./modules/user.js');
require('./modules/addresses.js');
require('./modules/cards.js');
require('./modules/newsletter.js');

require('./basics/service-worker-register.js');
require('./vendor/AddToHomeScreen.js');
